import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import router from '@/router'
import '@/assets/css/iconfont/iconfont.css'
import '@/styles/index.scss'
import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.css'
import 'normalize.css'
import jplugin from './utils/jplugin'
import { longClickDirective } from 'vue-long-click'
// import { Button, Form, Field } from 'vant'

// Vue.use(Button).use(Form).use(Field)

Vue.use(jplugin)
NutUI.install(Vue)

// import '@/styles/index.scss' // global css

const longClickInstance = longClickDirective({
  delay: 800,
  interval: 5000
})
Vue.directive('longclick', longClickInstance)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
